<template>
  <div class="pagination-container d-flex justify-content-between align-items-center flex-wrap w-100">
    
    <!-- Section Gauche : Sélecteur et Info -->
    <div class="d-flex align-items-center info-section">
      <div class="d-flex align-items-center page-size-control">
        <span class="text-label me-2 d-none d-sm-inline">Afficher</span>
        <CustomInput
          type="select"
          v-model="localPageSize"
          :options="formattedOptions"
          label-key="value"
          class="mini-select"
          :nullableVSelecte="false"
          :reduce="item => item.value"
        />
        <span class="text-label ml-2">par page</span>
      </div>
      
      <div class="vertical-divider mx-3 d-none d-md-block"></div>
      
      <div class="total-status text-muted small">
        <span class="font-weight-600 text-dark">{{ totalItems }}</span> 
        élément<span v-if="totalItems > 1">s</span> au total
      </div>
    </div>

    <!-- Section Droite : Navigation -->
    <div class="pagination-navigation">
      <b-pagination
        v-if="localPageSize"
        v-model="localPage"
        :total-rows="totalItems"
        :per-page="localPageSize"
        size="sm"
        align="center"
        limit="5"
        @input="onPageChange"
        class="mb-0 custom-pagination"
        hide-goto-end-buttons
      >
        <!-- Icônes de navigation -->
        <template #prev-text><i class="fas fa-chevron-left"></i></template>
        <template #next-text><i class="fas fa-chevron-right"></i></template>
      </b-pagination>
    </div>
  </div>
</template>

<script>
import CustomInput from "@/components/common/customInput.vue";

export default {
  name: "PaginationControls",
  components: { CustomInput },
  props: {
    page: { type: Number, default: 1 },
    pageSize: { type: Number, default: 10 },
    totalItems: { type: Number, required: true },
    pageSizeOptions: {
      type: Array,
      default: () => [5, 10, 20, 50]
    }
  },
  data() {
    return {
      localPage: this.page,
      localPageSize: this.pageSize
    };
  },
  computed: {
    formattedOptions() {
      return this.pageSizeOptions.map(size => ({ id: size, value: size }));
    }
  },
  watch: {
    page(val) { this.localPage = val; },
    pageSize(val) { this.localPageSize = val; },
    localPageSize() { this.onPageSizeChange(); }
  },
  methods: {
    onPageChange(newPage) { this.$emit('update:page', newPage); },
    onPageSizeChange() { this.$emit('update:pageSize', this.localPageSize); }
  }
};
</script>

<style scoped>
/* Conteneur principal */
.pagination-container {
  padding: 1.25rem 0;
  border-top: 1px solid #edf2f7;
  gap: 1rem;
}

/* Styles des textes */
.text-label {
  font-size: 0.85rem;
  color: #718096;
  font-weight: 500;
}

.total-status {
  white-space: nowrap;
}

.vertical-divider {
  width: 1px;
  height: 20px;
  background-color: #e2e8f0;
}

/* Sélecteur de taille personnalisé */
.mini-select {
  width: 80px;
}

:deep(.mini-select .vs__dropdown-toggle) {
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  height: 34px;
  padding: 0;
}

:deep(.mini-select .vs__selected) {
  font-weight: 600;
  color: #2d3748;
  font-size: 0.85rem;
}

/* --- Styles de la Pagination BootstrapVue --- */
:deep(.custom-pagination) {
  gap: 4px;
}

:deep(.custom-pagination .page-item .page-link) {
  border: 1px solid #e2e8f0;
  background-color: #ffffff;
  color: #4a5568;
  border-radius: 8px !important;
  min-width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.85rem;
  font-weight: 600;
  transition: all 0.2s ease;
  box-shadow: none !important;
}

/* Hover effect */
:deep(.custom-pagination .page-item:not(.active):not(.disabled) .page-link:hover) {
  background-color: #edf2f7;
  color: #4f46e5;
  border-color: #cbd5e1;
}

/* Active State */
:deep(.custom-pagination .page-item.active .page-link) {
  background-color: #4f46e5; /* Indigo */
  border-color: #4f46e5;
  color: #ffffff;
}

/* Disabled State */
:deep(.custom-pagination .page-item.disabled .page-link) {
  background-color: #f8fafc;
  color: #cbd5e1;
  border-color: #f1f5f9;
}

/* --- RESPONSIVE LOGIC --- */

@media (max-width: 768px) {
  .pagination-container {
    flex-direction: column;
    justify-content: center !important;
    text-align: center;
  }

  .info-section {
    flex-direction: column;
    gap: 0.75rem;
    width: 100%;
  }

  .pagination-navigation {
    width: 100%;
    display: flex;
    justify-content: center;
  }
}

@media (max-width: 480px) {
  /* Réduire la taille des boutons sur très petits écrans */
  :deep(.custom-pagination .page-item .page-link) {
    min-width: 32px;
    height: 32px;
    font-size: 0.75rem;
  }
}

.font-weight-600 {
  font-weight: 600;
}
</style>